export default __webpack_public_path__ + "static/media/circle-close-button.ec90b59d.png";